import { isOrgProfile, isPersonalProfile } from '@/component/Profile/types';
import { useProfileConfig } from '@/views/Profile/ProfileConfig.context';
import { getProfileQueryParams } from '@cyber-co/utils';
import { ProfileFragment, Role, useIsAdminQuery } from '@cyber/service/pwa';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import useAuth from '../useAuth';

const COULD_EDIT_PROFILE_ROLE = [Role.Editor, Role.Admin, Role.Owner];

export const useCouldEditProfile = () => {
  const router = useRouter();
  const handleFromQuery = router.query.handle as string;
  const { handle, id } = getProfileQueryParams(handleFromQuery);

  const { isPreview } = useProfileConfig();

  const { isLoggedIn } = useAuth();
  const { data, isLoading } = useIsAdminQuery({ handle, id }, { skip: (!handle && !id) || !isLoggedIn });
  const profileData = data?.profile.data as ProfileFragment;
  const [couldEdit, setCouldEdit] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (!isLoggedIn && typeof handle !== 'undefined') {
      setCouldEdit(false);
    } else {
      if (isPersonalProfile(profileData)) {
        setCouldEdit(!!profileData.isAdmin);
      } else if (isOrgProfile(profileData)) {
        // setCouldEdit(COULD_EDIT_PROFILE_ROLE.includes(profileData?.organization.currentAccess));
        setCouldEdit(false);
      }
    }
  }, [handle, isLoggedIn, isLoading, data, profileData]);

  return { isLoading: isLoading, couldEdit: couldEdit && !isPreview, isPreview };
};
